import { createContext } from "react";
import { IHomepageSections } from "../../../components/posts/models";
import { IAlert } from "./alert";
import { IAccount } from "../../models/accounts";
import { IShapeFile } from "../../../components/earthtwin/models";
import { IModal } from "../modal/modal";

const Context = createContext({
  account: {} as IAccount,
  setAccount: (account: IAccount) => {},
  shapeFiles: [] as IShapeFile[],
  setShapeFiles: (shapeFiles: IShapeFile[]) => {},
  homepageSections: {} as IHomepageSections,
  setHomepageSections: (homepageSections: IHomepageSections) => {},
  alert: {} as IAlert,
  setAlert: (alert: IAlert) => {},
  modal: {} as IModal,
  setModal: (modal: IModal) => {},
  cryptedUserID: "" as string,
  setCryptedUserID: (cryptedUserID: string) => {},
  cryptedCompanyID: "" as string,
  setCryptedCompanyID: (cryptedCompanyID: string) => {},
  cryptedRole: "" as string,
  setCryptedRole: (cryptedRole: string) => {},
  notificationCount: 0 as number,
  setNotificationCount: (notificationCount: number) => {},
  setCurrentPosition: (latitude: number, longitude: number, altitude: number) => {},
  currentPosition: { latitude: 0, longitude: 0, altitude: 0 } as { latitude: number; longitude: number; altitude: number },
});

export default Context;
